module.exports = "/images/Quote_thumb.png?8774d3a35690d3fd1983c2303d273dee";